import React, { Fragment, useMemo } from 'react';
import { useRouter } from 'next/router';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoEmail from 'eco-design/elements/eco-email';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EfCardsB from '@elem/ui/ef-cards-b';
import EfShopCardA from '@elem/ui/ef-shop-card-a';
import { needTermsCheckLocales } from '@elem/compPage/a-new-era-of-cool/config/pageConfig';
import { IPageStatus } from '@elem/compPage/a-new-era-of-cool/config/IPageStatus';
import { useProductStore } from '@elem/compPage/a-new-era-of-cool/ProductProvider';
import { getIsPadWidth } from '@elem/utils/devices';

import styles from './index.module.scss';
import { useLang } from '@/i18n';
import { useGlobal } from '@/utils/useGlobal';

export default function Comp() {
    const { getSystemTime } = useGlobal();
    const { locale }: any = useRouter();
    const { pageStatus } = useProductStore();
    const isMobile = getIsPadWidth();

    const { t: t1 } = useLang('theProduct.SectionB1');
    const { t: t2 } = useLang('theProduct.SectionB2');

    const WAVE_CONTACT_LIST: any = {
        eu: '926148913',
        uk: '2109435518',
        de: '1061412141',
        fr: '774048908',
        it: '1152966046',
        es: '1399480182',
        us: '1272859510',
        ca: '250347439',
    };

    const contactListId = [`${WAVE_CONTACT_LIST[locale]}`];

    const SITE_ID: any = {
        eu: '4427',
        uk: '4430',
        de: '4425',
        fr: '4428',
        it: '4429',
        es: '4426',
        us: '4423',
        ca: '4424',
    };

    const SUB_SOURCE = 'WEB_NEW_PRODUCT_SUB';

    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const dateString = `${year}-${month}-${day}`;

    const OptInOverride: any = {
        eu: true,
        uk: true,
        it: true,
        fr: true,
        es: true,
        de: true,
        us: false,
        ca: false,
    };

    const DateIds: any = {
        eu: '9690',
        uk: '9690',
        it: '9690',
        fr: '9690',
        es: '9690',
        de: '9690',
        us: '12555',
        ca: '12555',
    };
    const ProductIds: any = {
        eu: '7596',
        uk: '7596',
        it: '7596',
        fr: '7596',
        es: '7596',
        de: '7596',
        us: '11150',
        ca: '11150',
    };

    const WaveValues: any = {
        eu: ['45'],
        uk: ['45'],
        it: ['45'],
        fr: ['45'],
        es: ['45'],
        de: ['45'],
        us: ['12'],
        ca: ['12'],
    };
    const GlacierValues: any = {
        eu: ['43'],
        uk: ['43'],
        it: ['43'],
        fr: ['43'],
        es: ['43'],
        de: ['43'],
        us: ['13'],
        ca: ['13'],
    };

    const changeOptions = !!needTermsCheckLocales.includes(locale as string)
        ? [{ id: DateIds[locale], type: 'text', value: dateString, overwrite: false }]
        : [{ id: '9690', type: 'multiple', value: ['12'], overwrite: false }];

    const fields1 = [
        // 站点字段
        {
            id: SITE_ID[locale],
            type: 'single',
            value: 1,
            overwrite: true,
        },
        // Opt-In
        {
            id: '31',
            type: 'single',
            value: 1,
            overwrite: OptInOverride[locale],
        },
        // 订阅日期
        // {
        //     id: DateIds[locale],
        //     type: 'text',
        //     value: dateString,
        //     overwrite: true,
        // },
        // 产品字段
        {
            id: ProductIds[locale],
            type: 'multiple',
            value: WaveValues[locale],
            overwrite: false,
        },
        ...changeOptions,
    ];
    const fields2 = [
        // 站点字段
        {
            id: SITE_ID[locale],
            type: 'single',
            value: 1,
            overwrite: true,
        },
        // Opt-In
        {
            id: '31',
            type: 'single',
            value: 1,
            overwrite: OptInOverride[locale],
        },
        // 订阅日期
        // {
        //     id: DateIds[locale],
        //     type: 'text',
        //     value: dateString,
        //     overwrite: true,
        // },

        // 产品字段
        {
            id: ProductIds[locale],
            type: 'multiple',
            value: GlacierValues[locale],
            overwrite: false,
        },
        ...changeOptions,
    ];

    const wave5Map = {
        us: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744792304738/wave_card_5_us.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1744793011008/wave_card_5_us_h5.jpg',
        },
        ca: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744792305119/wave_card_5_ca.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1744793011258/wave_card_5_ca_h5.jpg',
        },
    };
    const glacier1Map = {
        us: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744792394714/glacier_card_1_us.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1744793108930/glacier_card_1_us_h5.jpg',
        },
        ca: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744792393823/glacier_card_1_ca.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1744793108715/glacier_card_1_ca_h5.jpg',
        },
    };
    const glacier4Map = {
        us: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744792394127/glacier_card_4_us.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1744793109410/glacier_card_4_us_h5.jpg',
        },
        ca: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744792394878/glacier_card_4_ca.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1744793109665/glacier_card_4_ca_h5.jpg',
        },
    };

    const itemsA = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744792304380/wave_card_1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1744793010804/wave_card_1_h5.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744792304964/wave_card_2.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1744793011890/wave_card_2_h5.jpg',

            desc: t1.rich('card2_desc', { sup: (text: any) => <sup>{text}</sup> }),
            title: t1('card2_title'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744792305345/wave_card_3.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1744793011691/wave_card_3_h5.jpg',

            desc: t1.rich('card3_desc', { sup: (text: any) => <sup>{text}</sup> }),
            title: t1('card3_title'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744792304545/wave_card_4.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1744793011493/wave_card_4_h5.jpg',

            desc: t1('card4_desc'),
            title: t1('card4_title'),
        },
        {
            pc: wave5Map[locale as keyof typeof wave5Map]?.pc || wave5Map.ca.pc,
            h5: wave5Map[locale as keyof typeof wave5Map]?.h5 || wave5Map.ca.h5,

            title: t1('card5_title'),
            desc: t1('card5_desc'),
        },
    ];
    const itemsB = [
        {
            pc: glacier1Map[locale as keyof typeof glacier1Map]?.pc || glacier1Map.ca.pc,
            h5: glacier1Map[locale as keyof typeof glacier1Map]?.h5 || glacier1Map.ca.h5,
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744792393962/glacier_card_2.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1744793110224/glacier_card_2_h5.jpg',

            desc: t2('card2_desc'),
            title: t2('card2_title'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744792394316/glacier_card_3.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1744793109979/glacier_card_3_h5.jpg',

            desc: t2('card3_desc'),
            title: t2('card3_title'),
        },
        {
            pc: glacier4Map[locale as keyof typeof glacier4Map]?.pc || glacier4Map.ca.pc,
            h5: glacier4Map[locale as keyof typeof glacier4Map]?.h5 || glacier4Map.ca.h5,

            desc: t2('card4_desc'),
            title: t2('card4_title'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744792394539/glacier_card_5.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1744793109126/glacier_card_5_h5.jpg',

            title: t2('card5_title'),
            desc: t2('card5_desc'),
        },
    ];

    const statusBProduct2Links: any = {
        us: {
            product_1: 'https://us.ecoflow.com/products/ecoflow-glacier-classic-portable-refrigerator',
            product_2: 'https://us.ecoflow.com/products/ecoflow-glacier-classic-portable-refrigerator',
            product_3: 'https://us.ecoflow.com/products/ecoflow-glacier-classic-55l-portable-refrigerator',
        },
        ca: {
            product_1: 'https://ca.ecoflow.com/products/ecoflow-glacier-classic-portable-refrigerator?variant=52405166473587',
            product_2: 'https://ca.ecoflow.com/products/ecoflow-glacier-classic-portable-refrigerator?variant=52405166408051',
            product_3: 'https://ca.ecoflow.com/products/ecoflow-glacier-classic-55l-portable-refrigerator',
        },
    };

    const itemsACardsStatusA = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744702224026/sectionb_product_1.png',
            label: t1('product1_label'),
            title: t1('product1_title'),
            desc: t1('product1_desc'),
            desc2: t1('product1_info_1'),
            moreLink: !!needTermsCheckLocales.includes(locale as string) ? `https://www.ecoflow.com/${locale}/wave-3-portable-air-conditioner` : '',
            moreText: !!needTermsCheckLocales.includes(locale as string) ? t1('product1_btn_text') : '',
        },
    ];
    const itemsACardsStatusB = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744702224026/sectionb_product_1.png',
            label: !!needTermsCheckLocales.includes(locale as string) ? '' : t1('product1_label'),
            title: t1('product1_title'),
            desc: t1('product1_desc'),
            desc2: t1('product1_info_1'),
            moreLink: !!needTermsCheckLocales.includes(locale as string)
                ? `https://${locale}.ecoflow.com/products/ecoflow-wave-3-portable-air-conditioner-with-heater`
                : `https://www.ecoflow.com/${locale}/wave-3-portable-air-conditioner`,
            moreText: t1('product1_btn_text'),
        },
    ];

    const IS_EU_SITE = ['eu', 'uk', 'de', 'fr', 'it', 'es'].includes(locale as string);
    const eu_wave3_statusA = useMemo(() => {
        if (IS_EU_SITE) {
            // 读取 query 参数用于测试
            let timer = '';
            if (typeof window !== 'undefined') {
                timer = new URLSearchParams(window.location.search).get('_timer') || '';
            }
            // 获取系统时间
            const systemTime = getSystemTime();
            const date = timer ? new Date(timer).getTime() : systemTime;
            const onlineTime = new Date('2025/05/12 15:00:00 GMT+8').getTime();
            return date < onlineTime;
        }
        return false;
    }, [getSystemTime, locale, pageStatus]);
    const itemsACards = useMemo(() => {
        if (IS_EU_SITE) {
            return eu_wave3_statusA ? itemsACardsStatusA : itemsACardsStatusB;
        }
        return pageStatus === IPageStatus.statusA ? itemsACardsStatusA : itemsACardsStatusB;
    }, [eu_wave3_statusA]);

    const itemsBCardsStatusA = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744702223846/sectionb_product_2.png',
            label: t2('product1_label'),
            title: t2('product1_title'),
            desc: t2('product1_desc'),
            desc2: t2('product1_info_1'),
            moreLink: !!needTermsCheckLocales.includes(locale as string) ? `https://www.ecoflow.com/${locale}/glacier-classic-portable-refrigerator` : '',
            moreText: t2('product1_btn_text'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744702224278/sectionb_product_3.png',
            label: t2('product2_label'),
            title: t2('product2_title'),
            desc: t2('product2_desc'),
            desc2: t2('product2_info_1'),
            moreLink: !!needTermsCheckLocales.includes(locale as string) ? `https://www.ecoflow.com/${locale}/glacier-classic-portable-refrigerator` : '',
            moreText: t2('product2_btn_text'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744702224508/sectionb_product_4.png',
            label: t2('product3_label'),
            title: t2('product3_title'),
            desc: t2('product3_desc'),
            desc2: t2('product3_info_1'),
            moreLink: !!needTermsCheckLocales.includes(locale as string) ? `https://www.ecoflow.com/${locale}/glacier-classic-portable-refrigerator` : '',
            moreText: t2('product3_btn_text'),
        },
    ];
    const itemsBCardsStatusB = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744702223846/sectionb_product_2.png',
            label: !!needTermsCheckLocales.includes(locale as string) ? '' : t2('product1_label'),
            title: t2('product1_title'),
            desc: t2('product1_desc'),
            desc2: t2('product1_info_1'),
            moreLink: !!needTermsCheckLocales.includes(locale as string)
                ? statusBProduct2Links[locale as string]?.product_1
                : `https://www.ecoflow.com/${locale}/glacier-classic-portable-refrigerator`,
            moreText: t2('product1_btn_text'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744702224278/sectionb_product_3.png',
            label: !!needTermsCheckLocales.includes(locale as string) ? '' : t2('product2_label'),
            title: t2('product2_title'),
            desc: t2('product2_desc'),
            desc2: t2('product2_info_1'),
            moreLink: !!needTermsCheckLocales.includes(locale as string)
                ? statusBProduct2Links[locale as string]?.product_2
                : `https://www.ecoflow.com/${locale}/glacier-classic-portable-refrigerator`,
            moreText: t2('product2_btn_text'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744702224508/sectionb_product_4.png',
            label: !!needTermsCheckLocales.includes(locale as string) ? '' : t2('product3_label'),
            title: t2('product3_title'),
            desc: t2('product3_desc'),
            desc2: t2('product3_info_1'),
            moreLink: !!needTermsCheckLocales.includes(locale as string)
                ? statusBProduct2Links[locale as string]?.product_3
                : `https://www.ecoflow.com/${locale}/glacier-classic-portable-refrigerator`,
            moreText: t2('product3_btn_text'),
        },
    ];

    const itemsBCards = pageStatus === IPageStatus.statusA ? itemsBCardsStatusA : itemsBCardsStatusB;

    return (
        <div className={`${styles.comp}`}>
            <EcoSectionCommon desc={t1('desc')} title={t1('title')} />
            <EcoSpaceSmall />
            <EfCardsB items={itemsA} />

            {(eu_wave3_statusA || !IS_EU_SITE) && (
                <div className="comp-box1">
                    <div className="comp-box1-l">
                        {!!needTermsCheckLocales.includes(locale as string) && pageStatus === IPageStatus.statusA && (
                            // <>
                            //     <span className="EmailCom-ms1">{t1('subscribe_title')}</span>
                            //     <span className="EmailCom-off">{t1('subscribe_price')}</span>
                            //     <span className="EmailCom-ms1">{t1('subscribe_and')}</span>
                            //     <span className="EmailCom-free">{t1('subscribe_free')}</span>
                            //     <span className="EmailCom-ms1">{t1('subscribe_thing')}</span>
                            // </>
                            <span className="EmailCom-ms1">{t1('subscribe_title')}</span>
                        )}

                        {!!needTermsCheckLocales.includes(locale as string) && pageStatus === IPageStatus.statusB && (
                            <span className="EmailCom-ms1">{t1('subscribe_info')}</span>
                        )}

                        {!needTermsCheckLocales.includes(locale as string) && (
                            <span className="EmailCom-ms1-2">
                                {t1.rich('subscribe_title2', {
                                    highlight: (text: string) => <span className="EmailCom-highlight">{text}</span>,
                                })}
                            </span>
                        )}
                    </div>
                    <div className="comp-box1-r">
                        <EcoEmail
                            contactListId={contactListId}
                            source={SUB_SOURCE}
                            fields={fields1}
                            defaultTermsCheck={!!needTermsCheckLocales.includes(locale as string)}
                        />
                    </div>
                </div>
            )}
            <div className={`ef-common-container SectionB-list-1 ${!(eu_wave3_statusA || !IS_EU_SITE) ? 'top-gap' : ''}`}>
                {itemsACards.map((item: any, index: number) => {
                    return (
                        <Fragment key={index}>
                            <EfShopCardA
                                position="imgL"
                                {...item}
                                dataLayer={{
                                    event: 'uaEvent',
                                    event_name: 'select_product',
                                    button_name: item?.moreText || t1('product1_btn_text'),
                                    product_name: item?.title,
                                    list_name: item?.title,
                                }}
                            />
                        </Fragment>
                    );
                })}
            </div>
            <EcoSpace />

            <EcoSectionCommon desc={t2('desc')} title={t2('title')} />
            <EcoSpaceSmall />
            <EfCardsB items={itemsB} className="SectionB-cards2" />

            <div className="comp-box1 SectionB-comp-box2">
                <div className="comp-box1-l">
                    {!!needTermsCheckLocales.includes(locale as string) && pageStatus === IPageStatus.statusA && (
                        // <>
                        //     <span className="EmailCom-ms1">{t2('subscribe_title')}</span>
                        //     <span className="EmailCom-off">{t2('subscribe_price')}</span>
                        //     <span className="EmailCom-ms1">{t2('subscribe_and')}</span>
                        //     <span className="EmailCom-free">{t2('subscribe_free')}</span>
                        //     <span className="EmailCom-ms1">{t2('subscribe_thing')}</span>
                        // </>
                        <span className="EmailCom-ms1">{t2('subscribe_title')}</span>
                    )}
                    {!!needTermsCheckLocales.includes(locale as string) && pageStatus === IPageStatus.statusB && (
                        <span className="EmailCom-ms1">{t2('subscribe_info')}</span>
                    )}
                    {!needTermsCheckLocales.includes(locale as string) && (
                        <span className="EmailCom-ms1-2">
                            {t2.rich('subscribe_title2', {
                                highlight: (text: string) => <span className="EmailCom-highlight">{text}</span>,
                            })}
                        </span>
                    )}
                </div>
                <div className="comp-box1-r">
                    <EcoEmail
                        contactListId={contactListId}
                        source={SUB_SOURCE}
                        fields={fields2}
                        defaultTermsCheck={!!needTermsCheckLocales.includes(locale as string)}
                    />
                </div>
            </div>
            <div className="ef-common-container SectionB-list-2">
                {itemsBCards.map((item: any, index: number) => {
                    return (
                        <Fragment key={index}>
                            <EfShopCardA
                                {...item}
                                dataLayer={{
                                    event: 'uaEvent',
                                    event_name: 'select_product',
                                    button_name: item?.moreText || t2('product1_btn_text'),
                                    product_name: `${item?.title}_${item.desc}`,
                                    list_name: item?.title,
                                }}
                            />
                        </Fragment>
                    );
                })}
            </div>
            {/* {!!isMobile && <EcoScrollLR selector=".SectionB-list-2" oneScrollWidth={288} />} */}

            <EcoSpace />
        </div>
    );
}
